module.exports = "<svg preserveAspectRatio=\"none\" viewBox=\"0 0 865.8 625.4\"><path d=\"M865.8 57.2L0 0v625.4l731.3-57.9z\" class=\"st61\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./svgs/skew-box-front.svg
// module id = 315
// module chunks = 1